exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-404{padding:110px 0}.error-404 img{display:block;width:170px;height:auto;margin:0 auto}.error-404 p{margin-top:16px;font-weight:500;font-size:15px;color:#999;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/jenkins/workspace/biyong_fe_biyong_zero/assets","/static":"/opt/jenkins/workspace/biyong_fe_biyong_zero/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69220a8b","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Error404.vue
// module id = 5YLO
// module chunks = 1 2 3 4 5